import processError from '../helpers/processError'
import { getToken } from '@auth/token-service'

export const addAuthToken = (request = {}, jwt = null) => {
  const authToken = jwt || getToken()
  request.headers = {
    ...request.headers,
    Authorization: `Bearer ${authToken}`,
  }
  return request
}

/**
 * Handle error response from fetch API
 * Processes error data and creates an Error with status code preserved
 * @param {Response} response - Fetch Response object
 * @returns {Promise<never>} Throws an Error with status code
 */
export const handleErrorResponse = async (response) => {
  const errorData = await response.text()
  let parsedError

  try {
    parsedError = JSON.parse(errorData)
  } catch {
    parsedError = { message: errorData }
  }

  const error = new Error(processError(parsedError))
  // Preserve status code for error detection
  error.status = response.status
  throw error
}
